<template>
<div id="login">
    <div class="row">
        <div class="col-md-4">
        </div>
        <!--
        <div class="col-md-4 well">
            <h2><span class="glyphicon glyphicon glyphicon-user"></span> Sign in</h2>
            <form class="form-signin" id="login-form" @submit.prevent="login()">
                <div class="form-group">
                    <input type="text" name="username" class="form-control input" v-model="username" placeholder="Username"  autocomplete="username" required="required" />
                </div>
                <div class="form-group">
                    <input type="password" name="password" class="form-control input" v-model="password" placeholder="Password" autocomplete="current-password" required="required"/>
                </div>
                <div class="btn-group">
                    <input type="submit" class="btn btn-primary" value="Sign in" />
                </div>
            </form>
        </div>
        <div class="col-md-4">
        </div>
        -->
    </div>
</div>
</template>

<script>
import { axios, apiURL, bus } from "../main";

export default {
  name: "login",
  data() {
    return {
      username:'',  
      password: '', 
      savePW: true
    }
  },
  computed: {
    user() {
      return this.$store.state.userStore.user
    }
  },
  methods: {
    login: async function() {
      try {
        var jqXHR = await axios.get(
          apiURL + "userManager.cfc?method=loginNext",
          { params: { username: this.username, password: this.password } }
        )
        this.setUser(jqXHR.data)
      } catch (e) {
        bus.$emit("error", "login fehlgeschlagen ( ")
      }
    },
    setUser: async function(jwt) {
      await this.$store.dispatch("setJWT", jwt)
      await this.$store.dispatch("loadNavigation")
      await this.$store.dispatch("loadProfile")
      if (
        this.$store.state.userStore.user.checkProfile > 0 &&
        this.$store.state.userStore.token.masterDomain === 0
      ) {
        // Produzent mit Flag "Profil prüfen"
        await this.$store.dispatch("loadUngelesen")
        this.$router.push("/" + this.$route.params.lang + "/profil")
      //} else if ((this.$store.state.userStore.token.masterDomain > 1000) || [62,66,70].includes(this.$store.state.userStore.token.masterDomain)) {
      } else if (this.$store.state.userStore.domain.modules === 'ZVM') {
        // Verwerter mit Ermächtigung
        this.$router.push("/" + this.$route.params.lang + "/zulagen")
      } else if (typeof this.$route.params.next != "undefined") {
        // Ziel-Route angegeben (aus DB2020)
        await this.$store.dispatch("loadUngelesen")
        this.$router.push("/" + this.$route.params.lang + "/" + this.$route.params.next)
      } else {
        await this.$store.dispatch("loadUngelesen")
        this.$router.push("/" + this.$route.params.lang + "/home")
      }
    }
  },
  created() {
    let self = this
    this.$nextTick(async function() {
      if (
        typeof self.$route.params.jwt != "undefined" &&
        self.$route.params.jwt.length > 10
      ) {
        self.setUser(self.$route.params.jwt)
      } else if (sessionStorage.getItem("jwt") != null) {
        self.setUser(sessionStorage.getItem("jwt"))
      }
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only 
<style scoped>
h1, h2 {
  font-weight: normal
}
</style>
-->